import { Vue } from 'vue-property-decorator'

export const settlementTypeMap = () => {
  return {
    ALL: { color: '#d1d5db', text: 'Todos', keys: [Vue.prototype.$gettext('ALL')] },
    EXEMPTION: { color: '#1aaf91', text: 'Isenção', keys: [50380001, Vue.prototype.$gettext('EXEMPTION')] },
    SETTLEMENT: { color: '#aca107', text: 'Cancelamento', keys: [50250002, Vue.prototype.$gettext('SETTLEMENT')] },
    PARTIAL_SETTLEMENT: { color: '#dfa9ce', text: 'Baixa Parcial', keys: [50380003, Vue.prototype.$gettext('PARTIAL_WRITE_OFF')] },
    FULL_SETTLEMENT: { color: '#dfa9ce', text: 'Baixa total', keys: [50380004, Vue.prototype.$gettext('TOTAL_WRITE_OFF')] },
    APPROVED: { color: '#d5e59e', text: Vue.prototype.$gettext('APPROVED_M'), keys: [50370004, Vue.prototype.$gettext('APPROVED_M')] },
    UPDATE: { color: '#d5e59e', text: Vue.prototype.$gettext('APPROVED_A'), keys: [50370006, Vue.prototype.$gettext('APPROVED_A')] },
    REPROVED: { color: '#f6bfb5', text: 'Reprovado', keys: [50370003, Vue.prototype.$gettext('REPROVED')] },
    IN_REVISION: { color: '#dfa9ce', text: 'Em revisão', keys: [50370003, Vue.prototype.$gettext('IN_REVISION')] },
    CANCELLED: { color: '#f6bfb5', text: 'Cancelado', keys: [50370005, Vue.prototype.$gettext('CANCELLED')] },
    PENDING_APPROVAL: { color: '#ffefa2', text: 'Em Aprovação', keys: [50370001, Vue.prototype.$gettext('PENDING_APPROVAL')] }
  }
}
